export const EDIT_ENGAGEMENTS_COMMENT_REQUEST = 'EDIT_ENGAGEMENTS_COMMENT_REQUEST';
export const EDIT_ENGAGEMENTS_COMMENT_SUCCESS = 'EDIT_ENGAGEMENTS_COMMENT_SUCCESS';
export const EDIT_ENGAGEMENTS_COMMENT_FAILURE = 'EDIT_ENGAGEMENTS_COMMENT_FAILURE';
